export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/offer_fill.83f98893.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};